import React from 'react';
import PropTypes from 'prop-types';
import {fetchSender} from "../../services";
import Fetch from "../../Elements/Fetch";
import DocumentsMigrationForm from "./DocumentsMigrationForm";

const DocumentsMigrationRoute = ({match, history, onSubmit}) => (
    <Fetch fetchFunction={fetchSender} fetchFunctionParams={match.params.id}>
        {sender => {
            const handleSubmit = onSubmit || (() => history.push('/senders/' + sender.id));
            return (
                <div style={{maxWidth: 800}}>
                    <DocumentsMigrationForm
                        sender={sender}
                        onSubmit={handleSubmit}
                    />
                </div>
            );
        }}
    </Fetch>
);

DocumentsMigrationRoute.propTypes = {
    onSubmit: PropTypes.func,
};

export default DocumentsMigrationRoute;